module.exports = __webpack_public_path__ + "images/284328457a66b523c06badd86eaf508d.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/images/intro_video/cuban_neighbourhood/susan.jpg
// module id = 169
// module chunks = 24